import { z } from "zod";

export const CompletionEffectsSchema = z
  .object({
    nextTaskType: z
      .string()
      .min(1)
      .nullable()
      .describe("Task created as this task's continuation; null when none follows")
      .meta({ visibleTo: "*" }),
    finalizesCase: z
      .boolean()
      .describe("Whether the completion finalizes the case after creating its tasks")
      .meta({ visibleTo: "*" }),
    alsoCreate: z
      .array(z.string().min(1))
      .describe("Tasks created alongside the next task, also linked to this task")
      .meta({ visibleTo: "*" }),
  })
  .strict()
  .describe("What completing the task does, snapshotted from its resolution and the user's choice");
export type CompletionEffects = z.infer<typeof CompletionEffectsSchema>;
